import {Modal} from "react-bootstrap";
import useVMStore from "../../store";

export default function DetailModel() {
    const {detailModel, showDetailModel} = useVMStore();

    return (<Modal show={detailModel !== ''} onHide={() => showDetailModel('')} size="lg" centered={true}>
        <Modal.Header closeButton/>
        <Modal.Body>
            <div className='w-100'>
                <img src={detailModel} alt="Detail" className='h-100 w-100' style={{objectFit: 'contain', maxHeight: '500px'}}/>
            </div>
        </Modal.Body>
    </Modal>);
}
